export const MIN_SIZE = 20;
export const LINK_DESTINATION_NONE = 'none';
export const LINK_DESTINATION_MEDIA = 'media';
export const LINK_DESTINATION_ATTACHMENT = 'attachment';
export const LINK_DESTINATION_CUSTOM = 'custom';
export const NEW_TAB_REL = ['noreferrer', 'noopener'];
export const ALLOWED_MEDIA_TYPES = ['image'];
export const MEDIA_ID_NO_FEATURED_IMAGE_SET = 0;
//# sourceMappingURL=constants.js.map